var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadImageFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#F2F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7143 14.4762C14.5559 14.4762 15.2381 13.794 15.2381 12.9524C15.2381 12.1108 14.5559 11.4286 13.7143 11.4286C12.8727 11.4286 12.1905 12.1108 12.1905 12.9524C12.1905 13.794 12.8727 14.4762 13.7143 14.4762Z",
    stroke: "#3F3939",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7619 8.38098H13.7143C9.90476 8.38098 8.38095 9.90479 8.38095 13.7143V18.2857C8.38095 22.0953 9.90476 23.6191 13.7143 23.6191H18.2857C22.0952 23.6191 23.6191 22.0953 23.6191 18.2857V14.4762",
    stroke: "#3F3939",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8571 10.6667H23.0476",
    stroke: "#3F3939",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9524 12.7619V8.57141",
    stroke: "#3F3939",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.89143 21.2953L12.6476 18.7734C13.2495 18.3696 14.1181 18.4153 14.659 18.8801L14.9105 19.101C15.5048 19.6115 16.4648 19.6115 17.059 19.101L20.2286 16.381C20.8229 15.8705 21.7829 15.8705 22.3771 16.381L23.6191 17.4477",
    stroke: "#3F3939",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImageFile);
export default __webpack_public_path__ + "static/media/upload-image-file.14e49373d59412c287004a7342432940.svg";
export { ForwardRef as ReactComponent };